export function omitKeys(source, excludeKeys) {
    const target = {};
    for (const key in source) {
        if (!excludeKeys.includes(key)) {
            target[key] = source[key];
        }
    }
    return target;
}
//# sourceMappingURL=omitKeys.js.map